import { render, staticRenderFns } from "./PollingServerStatus.vue?vue&type=template&id=45b34876"
import script from "./PollingServerStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./PollingServerStatus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports